<template>
  <div class="totals-box mb-2">
    <div class="totals-info-wrapper col">
      <router-link :to="{ path: '/jobs/edit/' + discount.job_id }" target="_blank">
        <div class="total-ref-id pointer">{{ discount.ref_id }}</div>
      </router-link>
    </div>
    <div class="totals-info-wrapper col">
      <div class="total-info">
        {{ discount.move_date }}
      </div>
    </div>
    <div class="totals-info-wrapper col">
      <div class="total-info">
        {{ discount.company }}
      </div>
    </div>
    <div class="totals-info-wrapper col">
      <div class="total-info">
        {{ discount.carrier }}
      </div>
    </div>
    <div class="totals-info-wrapper col">
      <div class="total-info">
        {{ discount.name }}
      </div>
    </div>
    <div class="totals-info-wrapper col">
      <div class="total-info-numbers">
        <template v-if="discount.discount_unit_type_id === 1">
          ${{ discount.amount }}
        </template>
        <template v-else-if="discount.discount_unit_type_id === 2">
          {{ discount.amount }} ({{ discount.amount_percent }}%)
        </template>
      </div>
    </div>
    <div class="totals-info-wrapper col">
      <div class="total-info">
        {{ discount.type }}
        <div v-if="$_can('job-discounts.change-type')" class="pointer menu w-25 text-center">
          <div id="dropdownMenuButtonEditDiscountType"
               data-toggle="dropdown"
               aria-haspopup="true"
               aria-expanded="false"
               v-if="discount.is_editable"
          >
            <i class="fa fa-ellipsis-h text-secondary menu-icon"
               aria-hidden="true"
            />
          </div>
          <div class="dropdown-menu"
               aria-labelledby="dropdownMenuButtonEditDiscountType"
               v-if="discount.is_editable"
          >
            <a v-for="discountType in discountTypes" :key="discountType.id" class="dropdown-item p-1 small"
               href="#"
               @click="changeType(discount.discount_id, discountType.id)"
            >
              {{ discountType.name }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';

export default {
  props: {
    discount: {
      type: Object,
      default: () => {},
    },
    discountTypes: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    changeType(discountId, typeId) {
      axios.put(`/job-discounts/${discountId}/change-type`, { type_id: typeId }).then(() => {
        this.$emit('update');
      });
    },
  },
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: none;
}
.totals-box {
  display: flex;
  justify-content: space-between;
  background: #ffffff;
  box-shadow: 0 2px 9px -4px rgba(15, 20, 54, 0.17), 0 7px 25px -3px rgba(50, 50, 93, 0.03);
  border-radius: 2px;
  height: 70px;
  padding: 8px 0 8px;
}
.totals-info-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.total-ref-id {
  font-weight: bold;
  font-size: 12px;
  color: #4c5669;
}
.total-ref-id:hover {
  color: #2962ff;
}
.total-info {
  color: #4c5669;
}
.total-info-numbers {
  display: flex;
  align-items: center;
  color: #4c5669;
}
.totals-icon {
  color: #c0c6cc;
}
.col-width-40 {
  width: 40%;
  justify-content: center;
}
.col-width-50 {
  width: 50%;
  justify-content: center;
}
.menu {
  position: absolute;
  top: 30%;
  right: 10%;
}
.menu-icon {
  transform: rotate(90deg);
}
.status {
  position: absolute;
  top: 34%;
  left: 23%;
}
</style>



// WEBPACK FOOTER //
// src/components/reports/DiscountsBlock.vue